import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { use, useEffect, useState, } from 'react';

import dayjs from 'dayjs';


import { Menu as MainMenu } from '../../components/Menu';
import { ModelDocumentData, ModelDocumentType, ModelDocumentStatus, ModelDocumentItem, DocumentIssuer } from '../../models/ModelDocument';

import { generateId } from '../../scripts/utils';

import { Box, Button, Divider, Typography, LinearProgress, FormControl, InputLabel, Select, MenuItem, } from '@mui/material';

import translations from '../../scripts/translations';

import { TierSelectBox } from '../../components/TierSelectBox';

import { getDocuments, updateDocument, deleteDocument } from '../../api/documents.js';

import { CreatFieldComponent } from '../../components/Fields';

import { useData } from '../../hooks/DataProvider';

import Popup from '../../components/Popup';

import { PaymentTerms, DefaultPaymentTerm, PaymentMethods } from '../../scripts/configData';

import { getAsingeIdx, deleteAsingeIdx } from '../../api/asingne_idx.js';
import { getGenerateFiles } from '../../api/generate_files.js';




const Document = () => {


    const { documentId } = useParams();
    const { language } = useData();

    const [searchParams] = useSearchParams();
    const documentType = searchParams.get('documentType');

    const btns = translations.button[language];
    const page = translations.pages.document[language];

    const [dataDocument, setDataDocument] = useState({});

    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingButton, setIsLoadingButton] = useState(false);

    const [popupData, setPopupData] = useState({
        open: false,
        code: null,
        id: null,
        fn: null,
    });

    const dueDate = dayjs().add(DefaultPaymentTerm.days, 'day').format('YYYY-MM-DD');


    const handleNew = (params = {}) => {

        const _id = generateId();
        const newDocument = {
            _id: _id,
            issueDate: dayjs().format('YYYY-MM-DD'),
            documentNumber: 'new',
            documentType: null,

            issuer: DocumentIssuer,
            customer: {},

            dueDate: dueDate,

            items: [],

            vatExemptionNotes: '',
            documentStatus: 'draft',
            memo: '',

            totalQuantity: 0,
            totalVatExcluded: 0,

            discountRate: 0,
            discountAmount: 0,

            totalVatExcludedAfterDiscount: 0,
            totalVatIncluded: 0,
            totalVat: 0,
            paymentTerms: DefaultPaymentTerm.key,
            paymentMethod: PaymentMethods[0].key, // Default to 'bankTransfer'


        }
        // If params are provided, merge them into the new document
        Object.assign(newDocument, params);

        console.log('New Document:', newDocument);

        setDataDocument(newDocument);

    };


    const handleSave = () => {
        setIsLoadingButton(true);

        const keyOrder = [
            '_id',
            'issueDate',
            'documentNumber',
            'documentType',
            'issuer',
            'customer',
            'dueDate',
            'items',
            'vatExemptionNotes',
            'documentStatus',
            'memo',
            'totalQuantity',
            'totalVatExcluded',
            'discountRate',
            'discountAmount',
            'totalVatExcludedAfterDiscount',
            'totalVatIncluded',
            'totalVat',
            'paymentTerms',
            'paymentMethod',
        ];

        const ordered = {};
        keyOrder.forEach(key => {
            ordered[key] = dataDocument[key];
        });


        updateDocument(ordered)
            .then((response) => {
                console.log('Document saved successfully:', response);
                setDataDocument(response);
            })
            .catch((error) => {
                console.error('Error saving document:', error);
            })
            .finally(() => {
                setIsLoadingButton(false);
            });
    };


    const setPaymentTermValue = (data) => {

        const term = PaymentTerms.find(term => term.key === data.paymentTerms);
        if (term) {

            switch (term.key) {
                case 'immediate':
                    dataDocument.paymentTerms = 'immediate';
                    dataDocument.dueDate = dayjs().format('YYYY-MM-DD');
                    break;
                case 'endOfMonth':
                    dataDocument.paymentTerms = 'endOfMonth';
                    dataDocument.dueDate = dayjs().endOf('month').format('YYYY-MM-DD');
                    break;
                case 'endOfMonth30':
                    dataDocument.paymentTerms = 'endOfMonth30';
                    dataDocument.dueDate = dayjs().endOf('month').add(30, 'days').format('YYYY-MM-DD');
                    break;
                case 'endOfMonth45':
                    dataDocument.paymentTerms = 'endOfMonth45';
                    dataDocument.dueDate = dayjs().endOf('month').add(45, 'days').format('YYYY-MM-DD');
                    break;
                case 'endOfMonth60':
                    dataDocument.paymentTerms = 'endOfMonth60';
                    dataDocument.dueDate = dayjs().endOf('month').add(60, 'days').format('YYYY-MM-DD');
                    break;
                default:
                    dataDocument.paymentTerms = term.key;
                    dataDocument.dueDate = dayjs().add(term.days, 'days').format('YYYY-MM-DD');
                    break;
            }

            setDataDocument({ ...dataDocument });
        }
    }


    useEffect(() => {
        if (documentId === 'new') {
            handleNew({ documentType: documentType });
        } else {
            setIsLoading(true);
            getDocuments({ _id: documentId })
                .then((data) => {
                    if (data && data.length > 0) {
                        setDataDocument(data[0]);
                    }
                }
                )
                .catch((error) => {
                    console.error('Error fetching document:', error);
                }).finally(() => {
                    setIsLoading(false);
                });
        };
    }, [documentId, documentType]);

    const sxDivider = {
        my: 2,
    };




    return (
        isLoading ? <LinearProgress /> : <>
            <MainMenu currentPage={'documents'} />

            <Box sx={{ flexDirection: 'row', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} >

                <Box>

                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 0 }} >
                        <Typography variant='subtitle1' sx={{ fontSize: '1rem', mr: 1 }} >{page.title} : </Typography>
                        <Typography variant='subtitle1' sx={{ fontSize: '1rem' }} color={dataDocument?.documentNumber === 'new' ? 'warning' : 'primary'}  > {dataDocument?.documentNumber}</Typography>
                    </Box>

                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'row-reverse', gap: 1, }} >
                    <Button variant='contained' loading={isLoadingButton} color='warning' onClick={handleSave}>{btns.save}</Button>
                    <Button variant='outlined' onClick={() => console.log('Delete')} disabled={dataDocument._id === 'new' ? false : true} color="secondary" >{btns.delete}</Button>
                    {/* <Button variant='outlined' onClick={handleDuplicate} disabled={shipmentId === 'new' ? true : false} >{btns.duplicate}</Button> */}
                    <Button variant='outlined' onClick={() => console.log(dataDocument)}>{btns.print}</Button>
                </Box>

            </Box>

            <Divider sx={sxDivider} />

            <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr', alignItems: 'center', gap: 2 }}>

                <CreatFieldComponent field={ModelDocumentData.issueDate} data={dataDocument} updateData={setDataDocument} />
                <CreatFieldComponent field={ModelDocumentData.documentType} data={dataDocument} updateData={setDataDocument} options={ModelDocumentType} />
                <CreatFieldComponent field={ModelDocumentData.documentStatus} data={dataDocument} updateData={setDataDocument} options={ModelDocumentStatus} />
                <CreatFieldComponent field={ModelDocumentData.paymentMethod} data={dataDocument} updateData={setDataDocument} options={PaymentMethods} />
                <CreatFieldComponent field={ModelDocumentData.paymentTerms} data={dataDocument} updateData={setPaymentTermValue} options={PaymentTerms} />
                <CreatFieldComponent field={ModelDocumentData.dueDate} data={dataDocument} updateData={setDataDocument} />


            </Box>

            <Divider sx={sxDivider} />

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }} >
                <TierSelectBox model={ModelDocumentData} size={4} data={dataDocument} updateData={setDataDocument} type={'customer'} forDocument={true} />
            </Box>

            <Divider sx={sxDivider} />

            {/* <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }} >


                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 4fr', gap: 4 }} >
                    <CreatFieldComponent field={ModelDocumentData.departureDate} data={dataDocument} updateData={setDataDocument} />
                    <TierSelectBox model={ModelDocumentData} data={dataDocument} updateData={setDataDocument} type={'origin'} size={2} />
                </Box>



                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 4fr', gap: 4 }} >
                    <CreatFieldComponent field={ModelDocumentData.arrivalDate} data={dataDocument} updateData={setDataDocument} />
                    <TierSelectBox model={ModelDocumentData} data={dataDocument} updateData={setDataDocument} type={'destination'} size={2} />
                </Box>

                <Divider sx={{ m: 0 }} />

                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr .2fr .5fr .5fr', gap: 2 }} >
                    <CreatFieldComponent field={ModelDocumentData.internalRef} data={dataDocument} updateData={setDataDocument} />
                    <Box></Box>
                    <CreatFieldComponent field={ModelDocumentData.prefix1} data={dataDocument} updateData={setDataDocument} />
                    <CreatFieldComponent field={ModelDocumentData.numeroVol1} data={dataDocument} updateData={setDataDocument} />

                </Box>

                <Divider sx={{ m: 0 }} />

                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr .2fr .5fr .5fr', gap: 2 }} >

                    <CreatFieldComponent field={ModelDocumentData.customerRef} data={dataDocument} updateData={setDataDocument} />
                    <Box></Box>
                    <CreatFieldComponent field={ModelDocumentData.prefix2} data={dataDocument} updateData={setDataDocument} />
                    <CreatFieldComponent field={ModelDocumentData.numeroVol2} data={dataDocument} updateData={setDataDocument} />
                </Box>

                

                <Divider sx={{ m: 0 }} />




                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 3 }} ></Box>


            </Box> */}

            {/* <CreatFieldComponent field={ModelShipment.revenue} data={dataShipement} updateData={setDataShipement} disabledInForm /> */}



            {/* Footer */}
            {popupData.open && <Popup popupData={popupData} setPopupData={setPopupData} />}
        </>
    )
}

export default Document;
